module.exports = __webpack_public_path__ + "static/media/p208d.3af5a3e5.jpg";